/**
 * @generated SignedSource<<bcbba1e510280029fdeb64530244df59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusHomeSeoNode$data = {
  readonly __typename: "Article";
  readonly " $fragmentSpreads": FragmentRefs<"articleSeoArticle">;
  readonly " $fragmentType": "plusHomeSeoNode";
} | {
  readonly __typename: "Author";
  readonly " $fragmentSpreads": FragmentRefs<"authorSeoAuthor">;
  readonly " $fragmentType": "plusHomeSeoNode";
} | {
  readonly __typename: "Topic";
  readonly " $fragmentSpreads": FragmentRefs<"topicSeoTopic">;
  readonly " $fragmentType": "plusHomeSeoNode";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "plusHomeSeoNode";
};
export type plusHomeSeoNode$key = {
  readonly " $data"?: plusHomeSeoNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusHomeSeoNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusHomeSeoNode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleSeoArticle"
        }
      ],
      "type": "Article",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "topicSeoTopic"
        }
      ],
      "type": "Topic",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "authorSeoAuthor"
        }
      ],
      "type": "Author",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "7052651e5b4b3c74a4fc480f05d606c9";

export default node;
